<app-programtitle title="Taxi fare calculator"></app-programtitle>
<p> Write a program to calculate taxi fare. If there are more than 5 passengers then add 25% to the fare.</p>
<app-editor code="{{program}}"> </app-editor>